import { useState, type FormEvent } from "react";
import { ApiError } from "../api.ts";
import { useAuth } from "../auth.tsx";
import { useI18n } from "../i18n.tsx";

/** Email + password. `onDone` runs once the session exists (the caller decides where to go next). */
export function AuthForm({ onDone, why }: { onDone?: () => void | Promise<void>; why?: string }) {
  const { t } = useI18n();
  const { signIn, signUp } = useAuth();
  const [up, setUp] = useState(false);
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  async function go(ev: FormEvent) {
    ev.preventDefault(); setMsg(null); setBusy(true);
    try {
      await (up ? signUp(f.name, f.email, f.password) : signIn(f.email, f.password));
      await onDone?.();
    } catch (e) {
      const k = e instanceof ApiError ? `err.${e.code.toLowerCase()}` : "";
      setMsg(k && t(k) !== k ? t(k) : t("err.auth"));
    } finally { setBusy(false); }
  }
  return (
    <form className="panel stack" onSubmit={go}>
      <h2 className="h2">{up ? t("a.signup") : t("a.signin")}</h2>
      <p className="muted small">{why ?? t("acc.benefit")}</p>
      {up && <label className="field"><span>{t("a.name")}</span><input required autoComplete="name" value={f.name} onChange={(x) => setF({ ...f, name: x.target.value })} /></label>}
      <label className="field"><span>{t("a.email")}</span><input required type="email" autoComplete="email" dir="ltr" value={f.email} onChange={(x) => setF({ ...f, email: x.target.value })} /></label>
      <label className="field"><span>{t("a.password")}</span><input required type="password" minLength={8} autoComplete={up ? "new-password" : "current-password"} dir="ltr" value={f.password} onChange={(x) => setF({ ...f, password: x.target.value })} /></label>
      {msg && <p className="err" role="alert">{msg}</p>}
      <button className="btn" type="submit" disabled={busy}>{t("a.go")}</button>
      <button type="button" className="link small" onClick={() => setUp(!up)}>{up ? t("a.switchIn") : t("a.switchUp")}</button>
    </form>
  );
}
